import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
const AllocationsTabs = () => {
  const location = useLocation();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Tabs, {
    type: "navigation",
    position: "sticky",
    value: location.pathname,
    "aria-label": "tabs navigation",
    "data-tut": "reactour__allocations-tabs"
  }, /*#__PURE__*/React.createElement(Tab, {
    component: RouterLink,
    label: t('allocations.allocations'),
    to: "/allocations",
    value: "/allocations",
    'custom-attribute': '757-allocation-page'
  }), /*#__PURE__*/React.createElement(Tab, {
    component: RouterLink,
    label: t('allocations.allocation_history'),
    to: "/allocations/allocations_history",
    value: "/allocations/allocations_history",
    'custom-attribute': '758-allocation-page'
  }));
};
export default AllocationsTabs;